import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#F5A539',

                light: '#F0F0EC',
                lightblue: '#7CA9C4',
                orange: '#F5A539',
                blue: '#08B2E3',
                darkblue: '#2D313E',
                dark: '#2e303c',

                green: '#7fac49',
                red: '#f44336',
            },
        },
    },
});
